import { render, staticRenderFns } from "./StudentSocialItem.vue?vue&type=template&id=574681ff&scoped=true&"
import script from "./StudentSocialItem.vue?vue&type=script&lang=js&"
export * from "./StudentSocialItem.vue?vue&type=script&lang=js&"
import style0 from "./StudentSocialItem.vue?vue&type=style&index=0&id=574681ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574681ff",
  null
  
)

export default component.exports